import React, { createContext, useContext, useState, useMemo } from 'react';

const AUTH_TOKEN_KEY = 'authToken';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setTokenState] = useState(() => {
    try {
      return localStorage.getItem(AUTH_TOKEN_KEY);
    } catch {
      return null;
    }
  });

  const setToken = (newToken) => {
    if (newToken) {
      localStorage.setItem(AUTH_TOKEN_KEY, newToken);
      setTokenState(newToken);
    } else {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      setTokenState(null);
    }
  };

  const logout = () => {
    setToken(null);
  };

  const isLoggedIn = Boolean(token);

  const value = useMemo(
    () => ({ isLoggedIn, setToken, logout }),
    [token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
